import React, { useEffect } from 'react';
import DeclinedToOppLoans from '../DeclinedToOppLoans';
import DailyLimitReached from '../DailyLimitReached';
import { PROMPTS } from '../../constants';
import usePrequal from '../../resources/prequal/usePrequal';
import Reapply from '../Reapply';
import Phone from '../Phone';
import Address from '../Address';
import CIP from '../CIP';
import RepairInfo from '../RepairInfo';
import PIIRetry from '../PIIRetry';
import FrozenFile from '../FrozenFile';
import LockedFile from '../LockedFile';
import Approved from '../Approved';
import ManualReview from '../ManualReview';
import Declined from '../Declined';
import CustomerNotIdentified from '../CustomerNotIdentified';
import ErrorUnhandled from '../ErrorUnhandled';
import GenerateDecision from '../GenerateDecision';
import InstallmentController from '../InstallmentController';
import RevolverController from '../RevolverController';

const Authenticated = () => {
  const { data: prequal } = usePrequal();

  // Prevent the decline reminder from rendering
  // until the user has seen the actual decline message
  useEffect(() => { sessionStorage.setItem('blockDeclineReminder', 'true'); }, []);
  useEffect(() => { window.scrollTo(0, 0); }, [prequal]);

  switch (prequal?.prompt) {
    case undefined:
      return <Reapply />;
    case PROMPTS.PROMPT_VERIFY_PHONE_MFA:
      return <Phone />;
    case PROMPTS.PROMPT_ADDRESS:
      return <Address />;
    case PROMPTS.PROMPT_CIP:
      return <CIP />;
    case PROMPTS.PROMPT_REPAIR_INFO:
      return <RepairInfo />;
    case PROMPTS.PROMPT_GENERATE_DECISION:
      return <GenerateDecision />;
    case PROMPTS.PROMPT_PII_RETRY:
      return <PIIRetry />;
    case PROMPTS.PROMPT_PREQUAL_APPROVED:
      return <Approved />;
    case PROMPTS.PROMPT_CUSTOMER_REVOLVING_OFFER:
      return <RevolverController />;
    case PROMPTS.PROMPT_CUSTOMER_INSTALLMENT_OFFER:
      return <InstallmentController />;
    case PROMPTS.PROMPT_MANUAL_REVIEW:
      return <ManualReview />;
    case PROMPTS.PROMPT_PREQUAL_DECLINED:
      return <Declined />;
    case PROMPTS.PROMPT_REFER_OPP_LOANS:
      return <DeclinedToOppLoans />;
    case PROMPTS.PROMPT_CUSTOMER_FROZEN:
      return <FrozenFile />;
    case PROMPTS.PROMPT_CUSTOMER_LOCKED:
      return <LockedFile />;
    case PROMPTS.PROMPT_CUSTOMER_UNFREEZE_FAILED:
      return <FrozenFile failedUnfreeze />;
    case PROMPTS.PROMPT_CUSTOMER_UNLOCK_FAILED:
      return <LockedFile failedUnlock />;
    case PROMPTS.PROMPT_UNFREEZE_LIMIT_REACHED:
    case PROMPTS.PROMPT_UNLOCK_LIMIT_REACHED:
      return <DailyLimitReached />;
    case PROMPTS.PROMPT_CUSTOMER_NOT_IDENTIFIED:
      return <CustomerNotIdentified />;
    case PROMPTS.PROMPT_EXTERNAL_ERROR:
    default:
      return <ErrorUnhandled />;
  }
};

export default Authenticated;
